<script>
    import { Router, link, Route } from "svelte-routing";
    import { fly } from 'svelte/transition';

    let headerClass = "pin";
    let y = 150;
    let lastY = 0;
    let lastDirection = "up";
    export let show = false;

    function changeClass(y) {
        let result = headerClass;
        const scrolledPxs = lastY - y;
        const scrollDirection = scrolledPxs < 0 ? "down" : "up";
        const changedDirection = scrollDirection !== lastDirection;
        if (changedDirection) {
        result = scrollDirection === "down" ? "unpin" : "pin";
        lastDirection = scrollDirection;
        }
        lastY = y;
        return result;
    }

    $: headerClass = changeClass(y);

</script>
<svelte:window bind:scrollY={y}/>

<header class="main-header {y > 150 ? 'fixed-top' : 'normal'}">
    <nav>
        <div class="container-fluid">
            <div class="d-flex align-items-center justify-content-between">
                <!-- Logo -->
                <div class="left-nav-logo-col">
                    <!-- normal size logo -->
                    <div class="logo logo-wrapper">
                        <a target="_top" href="/" id="site-logo" title="MangoMist Resort Bangalore" rel="home">             
                            <img class="img-responsive" src="/images/Mangomist-logo_165x165.png" alt="MangoMist Resort Bangalore">
                        </a>
                    </div>
                </div>
                <!-- Menu -->
                <div class="nav-col">
                    <!-- Brand and toggle get grouped for better mobile display -->
                    <div class="nav-menu">
                        <ul id="menu-mangomistmenu" class="menu">
                            <li id="" class="menu-item mega-menu has-submenu">
                                <a target="_top" href="/" class="" use:link>Resort</a>
                                <div class="second-lvl"><ul>
                                    <li id="" class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/about" use:link class="">About</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/gallery" class="" use:link>Gallery</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/restaurant" class="" use:link>Restaurant</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/activities" class="" use:link>Activities</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/amenities" class="" use:link>Amenities</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/awards-certificates" class="" use:link>Awards &amp; Certificates</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/mangomist-reviews" use:link class="">Reviews</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/mangomist-team" class="" use:link>Team</a>
                                    </li>
                                    <li id="" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                        <a target="_top" href="/careers" class="" use:link>Careers</a>
                                    </li>
                                </ul></div>
                            </li>
                            <li id="nav-menu-item-4729" class="menu-item menu-item-type-post_type menu-item-object-page  no-mega-menu  mega-menu four-columns-wide">
                                <a target="_top" href="/day-out-details" class="" use:link>Day Out</a>
                            </li>
                            <li id="nav-menu-item-2518" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                <a target="_top" href="/mangomist-accomodation" class="" use:link>Accomodation</a>
                            </li>
                            <li id="nav-menu-item-2519" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                <a target="_top" href="/camping" class="" use:link>Camping</a>
                            </li>
                            <li id="nav-menu-item-2520" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                <a target="_top" href="/map" class="" use:link>Map</a>
                            </li>
                            <li id="nav-menu-item-2521" class="menu-item menu-item-type-custom menu-item-object-custom  no-mega-menu  mega-menu four-columns-wide">
                                <a target="_top" href="/contact" class="" use:link>Contact</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>

<div class="mobile-menu">
    <div class="d-flex justify-content-between">
        <div class="left-nav-logo-col">
            <div class="logo-sm">
                <a target="_top" href="/" id="" title="MangoMist Resort Bangalore" rel="home">             
                    <img class="img-responsive" src="/images/Mangomist-logo_165x165.png" alt="MangoMist Resort Bangalore">
                </a>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <button class="btn menu-btn" on:click={() => show =  !show}>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
            </button>
            {#if show}
                <div class="mobile-menu-inner" transition:fly={{x: 250, opacity: 1}}>
                    <button class="close-mobile-nav" on:click={() => show =  !show}>X</button>
                    <ul id="" class="">
                        <li>
                            <a target="_top" href="/" use:link>Resort</a>
                            <ul class="sub-menu">
                                <li id="" class="">
                                    <a target="_top" href="/about" use:link class="">About</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/gallery" class="" use:link>Gallery</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/restaurant" class="" use:link>Restaurant</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/activities" class="" use:link>Activities</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/amenities" class="" use:link>Amenities</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/awards-certificates" class="" use:link>Awards &amp; Certificates</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/mangomist-reviews" use:link class="">Reviews</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/mangomist-team" class="" use:link>Team</a>
                                </li>
                                <li id="" class="">
                                    <a target="_top" href="/careers" class="" use:link>Careers</a>
                                </li>
                            </ul>
                        </li>
                        <li id="" class="">
                            <a target="_top" href="/day-out-details" class="" use:link>Day Out</a>
                        </li>
                        <li id="" class="">
                            <a target="_top" href="/mangomist-accomodation" class="" use:link>Accomodation</a>
                        </li>
                        <li id="" class="">
                            <a target="_top" href="/camping" class="" use:link>Camping</a>
                        </li>
                        <li id="" class="">
                            <a target="_top" href="/map" class="" use:link>Map</a>
                        </li>
                        <li id="" class="">
                            <a target="_top" href="/contact" class="" use:link>Contact</a>
                        </li>
                    </ul>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    header {
        position: absolute;
        transition: all 0.3s linear;
        left: 0;
        width: 100%;
        top: 0;
        z-index: 9999;
    }

    .container-fluid {
        padding-left: 8%;
        padding-right: 8%;
    }

    header ul li {
        list-style: none;
        padding: 10px 15px;
        display: inline-block;
    }

    header ul li a {
        font-weight: 500;
        text-decoration: none;
        border-bottom: 1px solid transparent;
        color: #fff;
        font-size: 1.125rem;
        display: block;
        position: relative;
        text-transform: uppercase;
        overflow: hidden;
        line-height: 2.25rem;
        letter-spacing: .15em;
    }

    a:hover {
        text-decoration: none;
    }

    .nav-menu {
        margin-top: 56px;
    }

    header ul li a:hover {
        color: #967a50;
        border-bottom: 1px solid #967a50;
    }

    :root {
        --header-height: 80px;
    }

    .fixed-top {
        background-color: rgba(15,36,83,0.85);
        position: fixed;
        height: 76px;
    }

    .fixed-top .logo img {
        max-height: 56px;
    }

    .fixed-top ul li a {
        font-size: .9rem;
    }

    .fixed-top .nav-menu {
        margin-top: 9px;
    }

    .has-submenu:hover .second-lvl {
        display: block;
    }

    .second-lvl {
        width: 74%;
        display: none;
        left: 50%;
        top: 83%;
        margin-left: -27%;
    }

    .second-lvl > ul > li {
        float: left;
        width: 25%;
        display: block;
    }

    .second-lvl > ul > li {
        padding: 0 10px;
    }

    .nav-menu li.mega-menu {
        position: inherit !important;
    }

    .mobile-menu {
        background-color: #0f2453;
        display: none;
        padding: 10px 0;
    }

    .mobile-menu-inner {
        position: fixed;
        top: 0;
        right: 0;
        height: 100%;
        width: 300px;
        max-width: 100%;
        overflow: auto;
        background-color: #0b1f45;
        z-index: 99998;
        padding: 25px 0 15px;
    }
    
    .logo-sm img {
        max-height: 50px;
        margin-left: 15px;
    }

    .menu-btn {
        display: flex;
        width: 22px;
        height: 23px;
        flex-flow: column;
        margin-right: 20px;
        align-items: center;
        justify-content: center;
    }
    .menu-btn span {
        background-color: #967a50;
        height: 2px;
        width: 22px;
        margin: 2px 0 2px 0;
    }

    .mobile-menu li {
        padding-left: 24px;
        padding-right: 20px;
        border-bottom: 1px solid rgba(255,255,255,0.05);
    }
    .mobile-menu li a {
        color: #fff;
        font-size: .9rem;
        font-weight: 300;
        letter-spacing: 2px;
        display: block;
        position: relative;
        padding: 8px 0;
        text-transform: uppercase;
        overflow: hidden;
        transition: color .3s ease-in-out;
        -moz-transition: color .3s ease-in-out;
        -webkit-transition: color .3s ease-in-out;
        -o-transition: color .3s ease-in-out;
    }

    .mobile-menu li ul li {
        border-bottom: none;
    }

    .close-mobile-nav {
        position: absolute;
        top: 12px;
        right: 12px;
        display: block;
        width: 30px;
        height: 30px;
        text-align: center;
        z-index: 99999;
        line-height: 24px;
        font-size: 24px;
        color: #967a50;
        background-color: transparent;
        cursor: pointer;
        border: 2px solid #967a50;
        transition: all .3s ease-in-out;
        -moz-transition: all .3s ease-in-out;
        -webkit-transition: all .3s ease-in-out;
        -o-transition: all .3s ease-in-out;
        font-size: 12px;
    }

    @media only screen and (min-width: 320px) and (max-width: 1020px) {
        .mobile-menu {
            display: block;
            position: fixed;
            top: 0;
            z-index: 9999;
            width: 100%;
        }

        :global(#home-page-carousel) {
            padding-top: 70px;
        }

        .main-header {
            display: none;
        }
    }
</style>